import fr from 'facet-rest';

export const SET_REQUEST_PARAMS = 'SET_REQUEST_PARAMS';
export const SET_COLLECTION = 'SET_COLLECTION';
export const ERROR_STATE = 'ERROR_STATE';
export const LOADING_STATE = 'LOADING_STATE';

export function setAccountError(error) {
  // TODO: format the error for humans
  return { type: ERROR_STATE, error };
}

export async function loadFromLink(relationship, dispatch, state, metaOverrideSet) {
  const isLink = relationship instanceof fr.Link;
  if (!isLink) {
    throw new TypeError('Account must be a resource');
  }

  try {
    const refreshParams = {
      params: state.requestParams,
    };
    dispatch({ type: LOADING_STATE, loading: true });
    let collection = await relationship.get(refreshParams);
    if (metaOverrideSet) {
      collection = collection.overrideMeta(metaOverrideSet);
    }
    dispatch({ type: SET_COLLECTION, collection });
  } catch (e) {
    dispatch(setAccountError(e));
  } finally {
    dispatch({ type: LOADING_STATE, loading: false });
  }
}
